var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container"},[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',[_c('span',{staticClass:"page-title"},[_vm._v("工单处理")])]),_c('el-breadcrumb-item',[_vm._v("研发人员工单")])],1),_c('work')],1)}
var staticRenderFns = []

export { render, staticRenderFns }